export const locales = {
	loadingLabel: 'Le contenu est en cours de chargement.'
};
